import { render, staticRenderFns } from "./EventMotorsport.vue?vue&type=template&id=c6fa5506&scoped=true"
import script from "./EventMotorsport.vue?vue&type=script&lang=js"
export * from "./EventMotorsport.vue?vue&type=script&lang=js"
import style0 from "./EventMotorsport.vue?vue&type=style&index=0&id=c6fa5506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fa5506",
  null
  
)

export default component.exports